"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var SubscriptionDetails = function (_a) {
    var _b, _c, _d, _e;
    var overview = _a.overview;
    return (React.createElement("div", null,
        React.createElement("div", { className: "form-input full-width" },
            React.createElement("label", null, "Active Debts"),
            React.createElement("input", { value: (_b = overview === null || overview === void 0 ? void 0 : overview.active_debts_count) !== null && _b !== void 0 ? _b : 0, disabled: true })),
        React.createElement("div", { className: "form-input form-input--with-tag full-width" },
            React.createElement("label", null, "Debts created"),
            React.createElement("div", { className: "flex-row form-input--with-tag-contents" },
                React.createElement("input", { value: (_c = overview === null || overview === void 0 ? void 0 : overview.debts_created_this_period) !== null && _c !== void 0 ? _c : 0, disabled: true }),
                React.createElement("div", { className: "form-input-tag" },
                    "This ",
                    overview.debts_creatable_period))),
        React.createElement("div", { className: "form-input form-input--with-tag full-width" },
            React.createElement("label", null, "Debts creatable"),
            React.createElement("div", { className: "flex-row form-input--with-tag-contents" },
                React.createElement("input", { value: (_d = overview === null || overview === void 0 ? void 0 : overview.debts_currently_creatable) !== null && _d !== void 0 ? _d : 0, disabled: true }),
                React.createElement("div", { className: "form-input-tag" },
                    "This ",
                    overview.debts_creatable_period))),
        React.createElement("div", { className: "form-input form-input--with-tag full-width" },
            React.createElement("label", null, "Max debts"),
            React.createElement("div", { className: "flex-row form-input--with-tag-contents" },
                React.createElement("input", { value: (_e = overview === null || overview === void 0 ? void 0 : overview.debts_creatable_per_period) !== null && _e !== void 0 ? _e : 0, disabled: true }),
                React.createElement("div", { className: "form-input-tag" },
                    "Per ",
                    overview.debts_creatable_period))),
        React.createElement("div", { className: "form-input form-input full-width" },
            React.createElement("label", null, "Period end"),
            React.createElement("div", { className: "flex-row form-input--with-tag-contents" },
                React.createElement("input", { value: (overview === null || overview === void 0 ? void 0 : overview.end_of_period)
                        ? new Date(overview.end_of_period).toLocaleDateString('en-GB', {
                            timeZone: 'UTC',
                        })
                        : '', disabled: true })))));
};
exports.default = SubscriptionDetails;
